// 自动生成文件 切勿改动!

export const projectName = 'message-control'
export const dvaNamespacePrefix = 'messageControl'
